module.exports = __webpack_public_path__ + "img/16.da53143d.jpg";